<div class="contents-channel">
  <div class="wrap">
    <div class="box-text">
      <div class="desc">운동 / 요리 / 음악을 만나보세요</div>
      <div class="title-top">언제 어디서나</div>
      <div class="title-bottom">밸런스브레인!</div>
    </div>
    <div class="box-image">
      <img class="img" src="assets/images/ch_icon_11.png">
      <span>
        홈케어 바로가기
        <mat-icon class="icon">keyboard_arrow_right</mat-icon>
      </span>
    </div>
  </div>
</div>
